import { MAX_VENUE_TYPE_EMOJI_LENGTH, MAX_VENUE_TYPE_LABEL_LENGTH, VenueTypeLabelsConfig } from '@ivy-monorepo/shared'

type VenueTypeLabelsTableProps = {
  value: VenueTypeLabelsConfig
  onChange: (value: VenueTypeLabelsConfig) => void
}

const VenueTypeLabelsTable = ({ value, onChange }: VenueTypeLabelsTableProps) => {
  const updateEntry = (type: VenueTypeLabelsConfig[number]['type'], patch: { label?: string; emoji?: string }) => {
    onChange(value.map(entry => (entry.type === type ? { ...entry, ...patch } : entry)))
  }

  return (
    <table className="map-filters-table">
      <thead>
        <tr>
          <th>Type</th>
          <th>Emoji</th>
          <th>Label</th>
        </tr>
      </thead>
      <tbody>
        {value.map(entry => (
          <tr key={entry.type}>
            <td>
              <code>{entry.type}</code>
            </td>
            <td>
              <input
                type="text"
                className="map-filter-input venue-type-emoji-input"
                maxLength={MAX_VENUE_TYPE_EMOJI_LENGTH}
                value={entry.emoji}
                onChange={e => updateEntry(entry.type, { emoji: e.target.value })}
              />
            </td>
            <td>
              <input
                type="text"
                className="map-filter-input"
                maxLength={MAX_VENUE_TYPE_LABEL_LENGTH}
                value={entry.label}
                onChange={e => updateEntry(entry.type, { label: e.target.value })}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default VenueTypeLabelsTable
